import React from 'react'

import { useConfiguration } from '../AppConfigProvider/AppConfigProvider'
import { useScript } from '../../hooks/useScript.hook'
import { initSocure } from '../../services/socure.service'

import { SocureDeviceContext, SOCURE_MODULE_URL } from '../../domain/socure'

const Socure: React.FC<{ context: SocureDeviceContext }> = ({ context }) => {
  const { configuration } = useConfiguration()

  // dynamically load module
  const isScriptLoaded = useScript(SOCURE_MODULE_URL)

  if (isScriptLoaded) {
    initSocure({ config: configuration, context })
  }

  return <></>
}

export default Socure
